import { E } from '@angular/cdk/keycodes';
import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { te } from 'date-fns/locale';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { ImportExcelComponent } from 'src/app/pages/commonImport/import-excel/import-excel.component';
import { CommonService } from 'src/app/services/common.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CrmBusinessEditComponent } from 'src/app/shared/crm-business-edit/crm-business-edit.component';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { ResourceAccess, getPageSize, download } from 'src/app/shared/utils/calsoft-validators';
import { CommonDownloadComponent } from '../common-download/common-download.component';

@Component({
  selector: 'calsoft-google-calendar-service-account',
  templateUrl: './google-calendar-service-account.component.html',
  styleUrls: ['./google-calendar-service-account.component.scss']
})
export class GoogleCalendarServiceAccountComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';
  protected _onDestroy = new Subject<void>();

  @Input() type: any = 1;
  @Input() leadId: any = 0;
  @Input() meetingType: any = 1;
  read: any = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  // sortParam: any = 'a.start_datetime' + "," + Constant.Dsc;

  sortParam: any = 'a.updated_at' + "," + Constant.Dsc;

  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  renderedData: any;
  pageSizeValue: any;
  search: any;
  filterSelectObj = [
    {
      name: 'Summary',
      property: 'a.summary',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Scheduled Date',
      property: 'a.start_datetime',
      type: 'date',
      position: 'secondValue',
      options: []
    },
    {
      name: 'Updated Date',
      property: 'a.updated_at',
      type: 'date',
      position: 'thirdValue',
      options: []
    },
    {
      name: 'Link',
      property: 'a.meet_link',
      type: 'text',
      position: 'fourthValue',
      options: []
    },

    {
      name: 'Meeting Start Date',
      property: 'a.start_time',
      type: 'date',
      position: 'fifthValue',
      options: []
    },
    {
      name: 'Meeting End Date',
      property: 'a.end_datetime',
      type: 'date',
      position: 'sixthValue',
      options: []
    },
    {
      name: 'Status',
      property: 'a.status',
      type: 'select',
      position: 'seeventhValue',
      options: [
        { "viewValue": "Pending", "value": "Pending" },
        { "viewValue": "Cancel", "value": "Cancel" },
        { "viewValue": "Completed", "value": "Completed" },
        { "viewValue": "Reschedule", "value": "Reschedule" }
      ]
    },
    {
      name: 'Owner',
      property: 'b.email',
      type: 'select',
      position: 'eigththValue',
      options: []
    },
    {
      name: 'Created Date',
      property: 'a.created_at',
      type: 'date',
      position: 'secondValue',
      options: []
    },

  ]
  elements: any;
  filterActive: boolean = false;
  resourcePrivilege: any;
  googleCalendarList: any;

  subscriberList: MatTableDataSource<unknown>;

  configData: any;
  GridType: any;
  filterType: any = 1;
  currentRouterPath: any;

  constructor(
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private router: Router,
    private commonService: CommonService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ecryptService: EcryptServiceService,
    private loaderService: LoaderService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.currentRouterPath = this.router.url;
  }

  mapperMap = new Map<string, string>();

  ngOnInit(): void {

    this.getResource();

    this.checkScreen();

    const encryptedConfig = localStorage.getItem('configSettingsData')

    if (encryptedConfig) {

      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        this.configData = JSON.parse(decrypted);
        this.GridType = this.configData.gridType;
        this.filterType = this.configData.filterType;

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    this.mapperMap.set('summary', ' a.summary');
    this.mapperMap.set('createdDate', ' a.created_at');
    this.mapperMap.set('updatedDate', 'a.updated_at');
    this.mapperMap.set('meetLink', 'a.meet_link');
    this.mapperMap.set('startDateTime', 'a.start_datetime');
    this.mapperMap.set('endDateTime', 'a.end_datetime');
    this.mapperMap.set('status', 'a.status');
    this.mapperMap.set('ownerId', 'a.owner_id');
    this.mapperMap.set('email', 'b.email');
    this.mapperMap.set('startTime', 'a.start_time');
  }

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.GOOGLECALENDER)
      .subscribe((data: any) => {

        if (!data.read && this.type != 2) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.read = data.read;
          this.resourcePrivilege = data;

          if (this.type == 2) {
            this.read = true;
          }
          // apply any stored search from crm-search redirect before making API calls
          this.applyStoredSearchIfPresent();

        }
      });
  }

  // Apply stored search/filter if redirected from crm-search
  applyStoredSearchIfPresent() {
    try {
      const keys = Object.keys(localStorage || {});
      let rawSe: string = null;
      let rawSelect: string = null;
      for (const k of keys) {
        const lower = k.toLowerCase();
        if (lower.includes('googlecalender') && lower.endsWith('se')) {
          rawSe = localStorage.getItem(k);
          break;
        }
      }
      if (!rawSe) {
        for (const k of keys) {
          const lower = k.toLowerCase();
          if (lower.includes('googlecalender') && lower.endsWith('select')) {
            rawSelect = localStorage.getItem(k);
            break;
          }
        }
      }

      const tryApply = (searchToApply: string) => {
        let attempts = 0;
        const maxAttempts = 8;
        const wait = 150;
        const attemptFn = () => {
          const token = this.loginService.getStorageToken(Constant.X_XSRF_TOKEN);
          if (token && token !== '') {
            this.page = Constant.PAGE;
            this.size = Constant.SIZE;
            this.filterActive = true;
            this.search = searchToApply;
            try { this.filterOption(this.search); } catch (e) { }
          } else {
            attempts++;
            if (attempts < maxAttempts) {
              setTimeout(attemptFn, wait);
            }
          }
        };
        attemptFn();
      };

      let applied = false;
      if (rawSe && rawSe.trim() !== '') {
        tryApply(rawSe);
        applied = true;
      } else if (rawSelect) {
        try {
          const sel = JSON.parse(rawSelect);
          if (sel) {
            const v = sel.summary || sel.description || sel.name || '';
            if (v && v.trim() !== '') {
              const searchTerm = `a.summary:*${v}* OR a.description:*${v}*`;
              tryApply(searchTerm);
              applied = true;
            }
          }
        } catch (e) {
          // ignore
        }
      }

      try {
        if (rawSe) {
          for (const k of Object.keys(localStorage)) {
            if (k.toLowerCase().includes('googlecalender') && k.toLowerCase().endsWith('se')) {
              localStorage.removeItem(k);
            }
          }
        }
        if (rawSelect) {
          for (const k of Object.keys(localStorage)) {
            if (k.toLowerCase().includes('googlecalender') && k.toLowerCase().endsWith('select')) {
              localStorage.removeItem(k);
            }
          }
        }
      } catch (e) { }

      if (!applied) {
        this.getAllGoogleCalendar();
      }
    } catch (e) {
      // ignore
    }
  }

  getAllGoogleCalendar() {
    this.filterActive = false;
    this.spinner = true;
    let additonalQuery = "null";
    this.googleCalendarServiceAccountService.searchGoogleCalendar(null, this.page, this.size, this.sortParam, additonalQuery).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = new MatTableDataSource();
        this.googleCalendarList = res['content'];
        this.elements = res['numberOfElements'];
        this.googleCalendarList.sort = this.sort;
        this.googleCalendarList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
      }
    )
  }


  DetectingRequestType() {
    if (!this.filterActive) {
      this.getAllGoogleCalendar();
    }
    else {
      this.filterOption(this.search);
    }
  }


  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }
  sortData(event) {
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    if (event.direction.length > 0) {
      if (event.direction == 'asc') {
        this.sortParam = this.mapperMap.get(event.active);
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.mapperMap.get(event.active);
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.DetectingRequestType();
    }
  }

  @Input()
  columns: ListColumn[] = [
    { name: 'Summary', property: 'summary', visible: true, isModelProperty: true },
    { name: 'Scheduled Date', property: 'startDateTime', visible: true, isModelProperty: false },
    { name: 'Updated Date', property: 'updatedDate', visible: false, isModelProperty: false },
    { name: 'Link', property: 'meetLink', visible: true, isModelProperty: false },
    { name: 'Meeting Start Time', property: 'startTime', visible: true, isModelProperty: false },
    { name: 'Meeting End Time', property: 'endDateTime', visible: true, isModelProperty: false },
    { name: 'Status', property: 'status', visible: true, isModelProperty: true },
    { name: 'owner', property: 'email', visible: true, isModelProperty: true },
    { name: 'Created Date', property: 'createdDate', visible: true, isModelProperty: false },
    { name: 'Error', property: 'error', visible: true, isModelProperty: false },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];

  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive = false
      this.getAllGoogleCalendar();
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
    this.loaderService.hide();
  }


  onFilterChange(value) {
    if (value == '') {
      this.getAllGoogleCalendar();
    } else {
      this.page = Constant.PAGE;

      let searchTerm = "summary:'" + '*' + value.trim() + '*' + "'"

      this.filterOption(searchTerm)


    }

  }


  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    let additonalQuery = "null";
    this.googleCalendarServiceAccountService.searchGoogleCalendar(this.search, this.page, this.size, this.sortParam, additonalQuery).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = res['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }


  addGoogleCalendar() {
    let id = 0;
    if (this.type == 1) {
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}`])
    } else {
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
    }

  }

  toggleError(row: any) {
    row.showFullError = !row.showFullError;
  }

  editGoogleCalendar(id) {
    if (this.type == 1) {
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}`])
    } else {
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
    }
  }


  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }



  openImportDataPopup() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: false,
      data: { url: 'excelImportSupplier' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {

      if (result['event'] != 'close') {
        this.getAllGoogleCalendar();
      }

    });

  }

  textAccount: string;

  deleteCalenderById(id: any) {
    this.spinner = true;
    this.googleCalendarServiceAccountService.deleteCalenderById(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllGoogleCalendar()
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      error => {
        this.spinner = false;
      })

  }

  copyToClipboard(text: string): void {


    if (text == null || text == undefined || text == '') {

      this.snackBar.open('Meeting link No Generated!', 'X', {
        duration: 3000,
        verticalPosition: 'bottom',
        panelClass: ['error'],
      });

    } else {

      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = text;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      this.snackBar.open('Copied to clipboard!', 'X', {
        duration: 3000,
        verticalPosition: 'bottom',
        panelClass: ['success'],
      });
    }


  }


  importExcel() {

    this.router.navigate([`/googleCalender/import-xl`])

  }

  status = [
    { "viewValue": "Pending", "value": "Pending" },
    { "viewValue": "Cancel", "value": "Cancel" },
    { "viewValue": "Completed", "value": "Completed" },
    { "viewValue": "Reschedule", "value": "Reschedule" }
  ]


  isAtStart = true;
  isAtEnd = false;
  @ViewChild('stepsWrapper') stepsWrapper!: ElementRef<HTMLDivElement>;

  checkScrollPosition(): void {
    const { scrollLeft, scrollWidth, clientWidth } = this.stepsWrapper.nativeElement;
    this.isAtStart = scrollLeft === 0;
    // Check if we are at the end (with a small tolerance for fractional pixels)
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  scroll(direction: 'left' | 'right'): void {
    const element = this.stepsWrapper.nativeElement;

    const scrollAmount = element.clientWidth * 0.8;

    if (direction === 'left') {
      element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    setTimeout(() => this.checkScrollPosition(), 500);
  }

  setupSteps: any[] = [
    // { id: 1, icon: 'auto_awesome', label: 'Personalize your CRM', status: 'active' },
    // { id: 2, icon: 'download', label: 'Import Lead', status: 'pending' },
  ];

  previousValues: { [key: string]: any } = {};

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
  }

  openBusinessEditDialog(): void {
    if (this.dialog.openDialogs.length > 0) {
      return; // Don't open again
    }
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        width: '800px',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });
    } else {

      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        minWidth: '100vw', height: '100vh',
        panelClass: '',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();

        }
      });

    }

  }


  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  refresh() {

    this.loaderService.show();
    this.onFilterChangeColumn(undefined)
    this.clearValue();

  }

  clearValue() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
  }
  isFilterPanelOpen = false;
  isFilterPanelColumnOpen = false;

  toggleFilterPanel(): void {
    this.isFilterPanelOpen = !this.isFilterPanelOpen;
    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
    }
  }
  toggleFilterColumnPanel(): void {
    this.isFilterPanelColumnOpen = !this.isFilterPanelColumnOpen;
    if (this.isFilterPanelColumnOpen) {
      this.isFilterPanelOpen = false;
    }
  }

  viewMode: 'compact' | 'comfortable' = 'compact';

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }

  closePopupTwo(event) {
    if (event == true) {
      this.toggleFilterColumnPanel();
    }

  }

  closePopupNew(event) {
    if (event == true) {
      this.toggleFilterPanel();
    }
  }

  isMobile = false;

  checkScreen() {
    this.isMobile = window.innerWidth <= 768; // adjust breakpoint as needed
  }

  trackByProp = (_: number, col: ListColumn) => col.property;


  closeEdit(leadId, key, value, element) {

    const backup = this.previousValues[key];

    element[key] = backup;

    this.clearValue()
  }

  backupValue(key: any, element: any) {
    this.previousValues[key] = element[key];

  }

  startEdit(rowId: any, colProperty: string, element: any, col: any) {

    const fieldMeta = this.filterSelectObj.find(f => f.property === colProperty);

    this.backupValue(colProperty, element);

    if (fieldMeta) {
      col.inputType = fieldMeta.type || 'text';
      col.options = fieldMeta.options || [];
    } else {
      col.inputType = 'text';
      col.options = [];
    }

    if (colProperty === 'startDateTime' || colProperty === 'endDateTime') {
      if (element[colProperty]) {
        const date = new Date(element[colProperty]);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        element[colProperty] = `${hours}:${minutes}`;
      }
    }

    this.editingCell = { rowId, colProperty };
    this.editingElement = element;
    this.editingCol = col;
  }

  saveEdit(rowId: number, colProperty: string, newValue: any, element: any) {
    this.editingCell = null;

    if (colProperty === 'startDateTime' || colProperty === 'endDateTime') {
      const originalDate = new Date(this.previousValues[colProperty]);
      newValue = this.getCombinedDateTime(originalDate, newValue);
    }

    if (colProperty === 'startDateTime') {

      element.startTime = element.startDateTime;
    }

    if (colProperty === 'endDateTime') {
      element.endTime = element.endDateTime;
    }


    let payload = { ...element };

    payload.operationType = "Change";

    payload[colProperty] = newValue;

    this.googleCalendarServiceAccountService.addOrEditGoogleCalendar(payload).subscribe(
      (response) => {
        if (response['status_code'] === Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(
            response['status_message'] || "Updated successfully",
            '×',
            { panelClass: 'success', verticalPosition: 'bottom', duration: 1000 }
          );

          element[colProperty] = newValue;
        } else {
          this.snackBar.open(
            response['status_message'] || "Update failed",
            '×',
            { panelClass: 'error', verticalPosition: 'bottom', duration: 2000 }
          );
        }
      },
      (err) => {
        this.snackBar.open("Server error while updating", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 2000
        });
      }
    );
  }

  getCombinedDateTime(date, time): Date {
    const [hour, minute] = time.split(':').map(Number);
    date = new Date(date);

    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  formatTime12(time: string): string {
    if (!time) return '';

    const [hours, minutes] = time.split(':').map(Number);

    const period = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12;

    return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }



  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  @Input() primaryTitle = 'Google Calender';

  @Input() groupBy: any = 'null';


  @Input() removeColummn: any = ['googleCalenderId', 'description', 'location', 'timeZone', 'eventId', 'attendees', 'endTime', 'data', 'createdBy', 'updatedBy', 'ownerId', 'meetingSummary', 'entityId', 'name', 'meetingDriveLink', 'type']

  exportDataFilter() {
    if (window.innerWidth < 768) {
      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        maxWidth: '100vh',
        height: '100vh',
        width: '100%', disableClose: true,
        data: {
          url: 'searchGoogleCalendar',
          obj: this.filterSelectObj,
          type: 'groupBy',
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: true,
          url2: 'searchGoogleCalendar',
          header: ['Summary', 'Scheduled Date', 'Meeting End Time', 'MeetLink', 'Meeting Start Time', 'Created Date', 'Updated Date', 'Status', 'Owner'],
          service: 'googleCalendarServiceAccountService',
          headerName: this.primaryTitle,
          dowloadFileName: this.primaryTitle,
          groupByValue: this.groupBy || 'null',
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });
    }
    else {
      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        height: '400px',
        disableClose: true,
        data: {
          url: 'searchGoogleCalendar',
          obj: this.filterSelectObj,
          type: 'groupBy',
          columns: this.columns,
          colummnToBeRemoved: this.removeColummn,
          useDefaultHeading: true,
          url2: 'searchGoogleCalendar',
          header: ['Summary', 'Scheduled Date', 'Meeting End Time', 'MeetLink', 'Meeting Start Time', 'Created Date', 'Updated Date', 'Status', 'Owner'],
          service: 'googleCalendarServiceAccountService',
          headerName: this.primaryTitle,
          dowloadFileName: this.primaryTitle,
          groupByValue: this.groupBy || 'null',
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });
    }
  }
}


